import { render, staticRenderFns } from "./menu_list.vue?vue&type=template&id=23da9bfb&scoped=true&"
import script from "./menu_list.vue?vue&type=script&lang=js&"
export * from "./menu_list.vue?vue&type=script&lang=js&"
import style0 from "./menu_list.vue?vue&type=style&index=0&id=23da9bfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da9bfb",
  null
  
)

export default component.exports